import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserDealersModel } from 'projects/Administration/src/app/business-entities/dealer-details.model';
import { MechanicTimeCode } from 'projects/Administration/src/app/business-entities/mechanic-time-code-model';
import { SelectListItemViewModel } from 'projects/Administration/src/app/business-entities/select-list-item-view-model';
import { DealerBusinessService } from 'projects/Administration/src/app/business-services/dealer.service';
import { MechanicTimeCodeBusinessService } from 'projects/Administration/src/app/business-services/mechanic-time-code.service';
import { CurrentLanguage } from '../../../../../../../../Autofacets-Core/src/app/common-services/current-language.service';
import * as Enums from './../../../../../../../../Autofacets-Core/src/app/utils/enums';

@Component({
  selector: 'app-edit-mechanic-time-code',
  templateUrl: './edit-mechanic-time-code.component.html'
})
export class EditMechanicTimeCodeComponent implements OnInit {
  editMechanicTimeCode = false;
  editMechanicTimeCodeForm: FormGroup;
  dealerList: Array<SelectListItemViewModel>;
  mechanictimeCode: MechanicTimeCode = {
    mechanicTimeCode: [],
    templateLanguageDetails: []
  }
  languageList: any[];
  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    public dealerBusinessService: DealerBusinessService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private currentLanguageService: CurrentLanguage,
    private mechanicTimeCodeService: MechanicTimeCodeBusinessService,
    private activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.languageList = this.currentLanguageService.LanguageList;
    this.editMechanicTimeCodeForm = this.formBuilder.group({
      dealerId: ['', [Validators.required]],
      service: new FormArray([]),
      isShowInDWO: [false],
    });
    this.mechanicTimeCodeService.isEdit = true;
    this.getUserDealers();
    this.getLanguage();
    let id = this.mechanicTimeCodeService.mechanicTimeCodeId
    this.getMechanicTimeCode(id);
  }
  async getUserDealers() {
    await this.dealerBusinessService.getUserDealersDropdown().then((response) => {
      this.dealerList = this.mapdealer(response.userDealersModel);
    })
  }

  mapdealer(array: UserDealersModel[]) {
    let supperArray = [];
    if (array && array.length > 0) {

      array.forEach(element=>{ 
        let single = Object();
        single.value = element.dealerId
        single.text = element.dealerName

        supperArray.push(single);
      })
    }
    return supperArray;
  }
  get t() { return this.cpf.service as FormArray; }
  getLanguage() {
    const number = this.currentLanguageService.LanguageList.length;
    if (this.t.length < number) {
      for (let i = this.t.length; i < number; i++) {
        this.t.push(this.formBuilder.group({
          languageId: ['',],
          name: ['', Validators.required],
          description: ['', Validators.required],
        }));
      }
    } else {
      for (let i = this.t.length; i >= number; i--) {
        this.t.removeAt(i);
      }
    }
  }
  OnClose() {
    this.activeModal.close({success:false})
  }
  get cpf() {
    return this.editMechanicTimeCodeForm.controls;
  }
  async getMechanicTimeCode(id: number) {
    this.spinner.show();
    await this.mechanicTimeCodeService.getMechanicTimeCodeById(id).then(result => {
        if (result) {
          this.mechanictimeCode = result;
          this.editMechanicTimeCodeForm.patchValue({
            service: this.mechanictimeCode.templateLanguageDetails,
            dealerId: this.mechanictimeCode.mechanicTimeCode[0].dealerId,
            isShowInDWO: this.mechanictimeCode.mechanicTimeCode[0].isShowInDWO
          });
        }
    })
    this.spinner.hide();
  }
  onSubmit() {
    let viewModel = {
      CreatedBy: '',
      DealerId: this.editMechanicTimeCodeForm.value.dealerId,
      IsShow: this.editMechanicTimeCodeForm.value.isShowInDWO,
      Lnlnvalue: this.editMechanicTimeCodeForm.value.service,
      Id: this.mechanicTimeCodeService.mechanicTimeCodeId
    }

    this.mechanicTimeCodeService.addMechanicTimeCodeList(viewModel).then(res => {

      if (res.responseCode === Enums.ErrorCodes.SuccessCode) {
        let succesMsg = this.translate.instant("lblMechanicTimeCodeUpdated");
        this.toastr.success(succesMsg);
        this.activeModal.close({
          success: true
        });
        this.spinner.hide();
      }
      else if (res.responseCode === Enums.ErrorCodes.InterrnalError) {
        let internalErrorMessage = this.translate.instant("lblMechanictimeCodeAlreadyAdded");
        this.spinner.hide();
        this.toastr.error(internalErrorMessage);
      }
    });
  }
}
